import getApprovalModuleRoutes from '@hrms/approval/constants/routes';
import getSeperationBlackListModuleRoutes from '@hrms/blacklist-separation/constant/routes';
import { getBulkCreationModuleRoutes } from '@hrms/bulk-creation/constant/route';
import { getFlexManagementModuleRoutes } from '@hrms/flex-management/constant/routes';
import getFTFlexModuleRoutes from '@hrms/ft-flex/slot-management/constants/routes';
import getGrievanceModuleRoutes from '@hrms/grievance-management/constant/route';
import getHiringAndLeadsModuleRoutes from '@hrms/hiring-and-leads/constants/routes';
import getBaseModuleRoutes from '@hrms/home/constants/routes';
import getIncentiveManagementRoutes from '@hrms/incentive-management/constants/routes';
import getLeaveRoutes from '@hrms/leaves/constants/routes';
import getProfileModuleRoutes from '@hrms/profile/constants/routes';
import getReportsRoutes from '@hrms/reports/constants/routes';
import getTeamManagementModuleRoutes from '@hrms/team-management/constants/routes';
import getVendorsRoutes from '@hrms/vendors/constants/routes';
import { getAttendanceModuleRoutes } from '../../attendance/constants/routes';
import getAUMModuleRoutes from '../../aum/constants/routes';
import getPayoutsAndIncentiveModuleRoutes from '../../payouts-and-incentive/constants/routes';
import getSiteManagementModuleRoutes from '../../site-management/constants/routes';
import getTransferManagementRoutes from '../../transfer-management/constants/routes';
import { ModuleRoutesComponentInterface } from './types';
import { getReferralModuleRoutes } from '@hrms/referral/constants/routes';
import getVendorsReportRoutes from '@hrms/vendor-report/constants/routes';
import getAddendumManagementRoute from '@hrms/addendum-management/constants/route';
import getITApprovalsModuleRoutes from '@hrms/approval/constants/itApprovalRoutes';

const getModuleRoutes: ModuleRoutesComponentInterface = () => {
  const aumRoutes = getAUMModuleRoutes();
  const routes = getBaseModuleRoutes();
  const siteManagementRoutes = getSiteManagementModuleRoutes();
  const leaveRoutes = getLeaveRoutes();
  const separationblackListRoutes = getSeperationBlackListModuleRoutes();
  const approvalRoutes = getApprovalModuleRoutes();
  const reportsRoutes = getReportsRoutes();
  const teamManagementRoutes = getTeamManagementModuleRoutes();
  const vendorsRoutes = getVendorsRoutes();
  const hiringAndLeadsModuleRoutes = getHiringAndLeadsModuleRoutes();
  const attendanceLog = getAttendanceModuleRoutes();
  const flexManagementRoutes = getFlexManagementModuleRoutes();
  const ftFlexRoutes = getFTFlexModuleRoutes();
  const bulkUpload = getBulkCreationModuleRoutes();
  const grievanceManagement = getGrievanceModuleRoutes();
  const transferManagementRoutes = getTransferManagementRoutes();
  const profileRoutes = getProfileModuleRoutes();
  const payoutsAndIncentiveModuleRoutes = getPayoutsAndIncentiveModuleRoutes();
  const incentiveManagementRoutes = getIncentiveManagementRoutes();
  const referralManagementRoutes = getReferralModuleRoutes();
  const vendorDownloadRoutes = getVendorsReportRoutes();
  const addendumManagementRoute = getAddendumManagementRoute();
  const itApprovalsRoutes = getITApprovalsModuleRoutes();

  return [
    ...hiringAndLeadsModuleRoutes,
    ...routes,
    ...siteManagementRoutes,
    ...attendanceLog,
    ...approvalRoutes,
    ...itApprovalsRoutes,
    ...leaveRoutes,
    ...transferManagementRoutes,
    ...separationblackListRoutes,
    ...grievanceManagement,
    ...payoutsAndIncentiveModuleRoutes,
    ...addendumManagementRoute,
    ...incentiveManagementRoutes,
    ...referralManagementRoutes,
    ...flexManagementRoutes,
    ...ftFlexRoutes,
    ...vendorsRoutes,
    ...vendorDownloadRoutes,
    ...teamManagementRoutes,
    ...bulkUpload,
    ...reportsRoutes,
    ...aumRoutes,
    ...profileRoutes,
  ];
};
export default getModuleRoutes;
